import { Button, Form, Modal, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateProductForsale } from "../../../../api/products";

export default function UpdateForsale({
  isVisible,
  setVisible,
  is_for_sale,
  productId,
}: any) {
  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: updateProductForsale,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["products", productId] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    const data = { is_for_sale: !is_for_sale };
    mutate({ product_id: productId, data });
  };

  const action = is_for_sale ? "Remove : Product Sale" : "Add : Product Sale";

  return (
    <Modal
      title={`${action}`}
      open={isVisible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="updateProductForsale"
          htmlType="submit"
          onSubmit={onSubmit}
          loading={isLoading}
          className="border-0 bg-blue-600 text-white"
        >
          {action}
        </Button>,
      ]}
    >
      <Form
        id="updateProductForsale"
        form={form}
        name="control-ref"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="">
          {is_for_sale ? (
            <div className="">
              Are you Sure you want to{" "}
              <span className="text-red-600 text-bold">{action}</span> This
              Product
            </div>
          ) : (
            <div className="">
              Are you Sure you want to{" "}
              <span className="text-green-600 text-bold">{action}</span>
            </div>
          )}
        </div>
      </Form>
    </Modal>
  );
}
